<input type="text" [(ngModel)]="referalId"/> <input type="button" (click)="search()" value="Search"/>

<table>
    <thead>
        <th>Date time</th>
        <th>User</th>
        <th>Type</th>
        <th>Success</th>
        <th>Request Data</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of logs">
            <td>{{item.actionTime | date: 'MM/dd/yyyy HH:mm'}}</td>
            <td>{{item.displayAction || item.actionType}}</td>
            <td>{{item.displayName}}</td>
            <td>{{item.responseStatus >= 200 && item.responseStatus <= 300 ? 1 : 0}}</td>
            <td>
                <span *ngFor="let obj of item.requestBody|keyvalue">
                    {{obj.key}}: <span style="font-weight: 600;">{{obj.value}}</span>
                </span>
            </td>
        </tr>
    </tbody>
</table>